﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_informationNoHeaderListItem from './tpl/informationNoHeaderListItem.html';

export default Marionette.ItemView.extend({
    getTemplate: function () {
        return tpl_informationNoHeaderListItem({ model: this.model.toJSON() });
    }
});
